<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户ID">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="货币类型">
<!--                  <el-input  v-model="queryForm.currencyType"></el-input>-->
                  <el-select placeholder="请选择货币类型" clearable v-model="queryForm.currencyType" style="width: 177px">
                      <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="请求ID">
                  <el-input style="width: 177px;" v-model="queryForm.requestId"></el-input>
              </el-form-item>

              <el-form-item label="操作时间">
                  <el-date-picker
                      style="width: 180px"
                      v-model="timeRange"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>

              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppMoneyRecordInList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppMoneyRecordIn"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppMoneyRecordIn(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppMoneyRecordIn(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>

        <span title="导出数据" class="icon-box" @click="exportMppMoneyRecordInList">
            <Icon color="#606266">
                <ArrowDownload24Regular />
            </Icon>
        </span>

        <span
          class="icon-box"
          @click="refreshMppMoneyRecordInList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppMoneyRecordInList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="outputMoney"
        label="输出金额"
        width="180"
      > </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="originalMoney"
        label="初始金额"
        width="180"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="money"
	    label="金额"
	    width="180"
	  > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="restMoney"
        label="剩余金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyType"
        label="货币类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ getCurrencyType(scope.row.currencyType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyRatio"
        label="转换比例"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="detail"
        label="详情"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exeTimes"
        label="执行次数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exeStatus"
        label="执行URL状态"
        width="180"
      >
          <template slot-scope="scope">
              {{ scope.row.exeStatus == 1 ? '成功' : '失败' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="requestId"
        label="请求ID"
        width="180"
      > </el-table-column>
      
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppMoneyRecordIn(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppMoneyRecordIn(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppMoneyRecordIn(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppMoneyRecordInStates[mppMoneyRecordInState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppMoneyRecordIn"
          ref="mppMoneyRecordInForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户ID"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppMoneyRecordIn.userId"-->
<!--              :disabled="mppMoneyRecordInState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="mppMoneyRecordInState == 'check'"
                           labelValue="id" :value="mppMoneyRecordIn.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="输出金额"
            prop="outputMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.outputMoney"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="金额"
            prop="money"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.money"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="初始金额"
            prop="originalMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.originalMoney"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="剩余金额"
            prop="restMoney"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.restMoney"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="货币类型"
            prop="currencyType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppMoneyRecordIn.currencyType"-->
<!--              :disabled="mppMoneyRecordInState == 'check'"-->
<!--            ></el-input>-->
              <el-select placeholder="请选择货币类型" clearable v-model="mppMoneyRecordIn.currencyType" style="width: 177px" :disabled="mppMoneyRecordInState == 'check'">
                  <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="转换比例"
            prop="currencyRatio"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.currencyRatio"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="详情"
            prop="detail"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.detail"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="执行次数"
            prop="exeTimes"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.exeTimes"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="执行URL状态"
            prop="exeStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppMoneyRecordIn.exeStatus"-->
<!--              :disabled="mppMoneyRecordInState == 'check'"-->
<!--            ></el-input>-->
              <el-select placeholder="请选择执行URL状态" clearable v-model="mppMoneyRecordIn.exeStatus" style="width: 177px" :disabled="mppMoneyRecordInState == 'check'">
                  <el-option label="成功" :value="1"> </el-option>
                  <el-option label="失败" :value="0"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="请求ID"
            prop="requestId"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="mppMoneyRecordIn.requestId"
              :disabled="mppMoneyRecordInState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppMoneyRecordInState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppMoneyRecordInList();
                    this.getMppMoneyRecordInList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppMoneyRecordInList();
                    this.getMppMoneyRecordInList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                timeRange: [],
                queryForm:{
                    startTime: '',
                    endTime: '',
                     userId: '', //用户ID
                     outputMoney: '', //输出金额
                     money: '', //金额
                     originalMoney: '', //初始金额
                     restMoney: '', //剩余金额
                     currencyType: '', //货币类型
                     currencyRatio: '', //转换比例
                     detail: '', //详情
                     exeTimes: '', //执行次数
                     exeStatus: '', //执行URL状态 1 成功0失败
                     requestId: '', //请求ID
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppMoneyRecordInState: 'add',
                mppMoneyRecordInStates: {
                    add: '新建兑入记录',
                    check: '查看兑入记录',
                    edit: '修改兑入记录'
                },

                multipleSelection: [],
                mppMoneyRecordInList: [],
                mppMoneyRecordIn: {
                    id: '', //ID
                    userId: '', //用户ID
                    outputMoney: '', //输出金额
                    money: '', //金额
                    originalMoney: '', //初始金额
                    restMoney: '', //剩余金额
                    currencyType: '', //货币类型
                    currencyRatio: '', //转换比例
                    detail: '', //详情
                    exeTimes: '', //执行次数
                    exeStatus: '', //执行URL状态 1 成功0失败
                    requestId: '', //请求ID
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    outputMoney: [{ required: true, message: '输出金额不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '金额不能为空', trigger: 'blur' }],
                    originalMoney: [{ required: true, message: '初始金额不能为空', trigger: 'blur' }],
                    restMoney: [{ required: true, message: '剩余金额不能为空', trigger: 'blur' }],
                    currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                    currencyRatio: [{ required: true, message: '转换比例不能为空', trigger: 'blur' }],
                    detail: [{ required: true, message: '详情不能为空', trigger: 'blur' }],
                    exeTimes: [{ required: true, message: '执行次数不能为空', trigger: 'blur' }],
                    exeStatus: [{ required: true, message: '执行URL状态 1 成功0失败不能为空', trigger: 'blur' }],
                    requestId: [{ required: true, message: '请求ID不能为空', trigger: 'blur' }],
                },
                currencyTypeList: []
            };
        },
        created() {
            this.getMppMoneyRecordInList();
            this.getCurrencyTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppMoneyRecordInList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppMoneyRecordInList = [];
            },
            //获取货币类型
            getCurrencyTypeList() {
                get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                    if (res.success) {
                        this.currencyTypeList = res.enumList;
                    }
                });
            },
            getCurrencyType(type) {
                for (const index in this.currencyTypeList) {
                    if (this.currencyTypeList[index].key == type) {
                        return this.currencyTypeList[index].value;
                    }
                }
            },
            getValueUser(value) {
                this.mppMoneyRecordIn.userId = value
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },

            resetDialog() {
                this.mppMoneyRecordInState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      outputMoney: '', //输出金额
                      money: '', //金额
                      originalMoney: '', //初始金额
                      restMoney: '', //剩余金额
                      currencyType: '', //货币类型
                      currencyRatio: '', //转换比例
                      detail: '', //详情
                      exeTimes: '', //执行次数
                      exeStatus: '', //执行URL状态 1 成功0失败
                      requestId: '', //请求ID
                      startTime: '',
                      endTime: '',
                };
                this.timeRange = [];
                this.getMppMoneyRecordInList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppMoneyRecordIn = {
                      id: '', //ID
                      userId: '', //用户ID
                      outputMoney: '', //输出金额
                      money: '', //金额
                      originalMoney: '', //初始金额
                      restMoney: '', //剩余金额
                      currencyType: '', //货币类型
                      currencyRatio: '', //转换比例
                      detail: '', //详情
                      exeTimes: '', //执行次数
                      exeStatus: '', //执行URL状态 1 成功0失败
                      requestId: '', //请求ID
                };
            },
            submitForm() {
                if (this.mppMoneyRecordInState == 'add') {
                    this.$refs.mppMoneyRecordInForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/moneyrecordin/add`,{ ...this.mppMoneyRecordIn }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppMoneyRecordInList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppMoneyRecordInState == 'edit') {
                    this.$refs.mppMoneyRecordInForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/moneyrecordin/edit`,{ ...this.mppMoneyRecordIn }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppMoneyRecordInList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppMoneyRecordIn() {
                this.showDialog = true;
                this.mppMoneyRecordInState = 'add';
            },
            checkMppMoneyRecordIn(mppMoneyRecordInId) {
                console.log(mppMoneyRecordInId);
                this.currentMppMoneyRecordInId = mppMoneyRecordInId;

                this.getMppMoneyRecordInById();
                this.showDialog = true;
                this.mppMoneyRecordInState = 'check';
            },
            editMppMoneyRecordIn(mppMoneyRecordInId) {
                console.log('mppMoneyRecordIn', mppMoneyRecordInId);
                if (mppMoneyRecordInId) {
                    this.currentMppMoneyRecordInId = mppMoneyRecordInId;
                    this.getMppMoneyRecordInById();
                } else {
                    this.mppMoneyRecordIn = { ...this.mppMoneyRecordIn, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppMoneyRecordInState = 'edit';
            },
            deleteMppMoneyRecordIn(mppMoneyRecordInId) {
                let ids = '';
                if (mppMoneyRecordInId) {
                    ids = mppMoneyRecordInId;
                } else {
                    ids = this.multipleSelection.map((mppMoneyRecordIn) => mppMoneyRecordIn.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/moneyrecordin/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppMoneyRecordInList();
                                this.getMppMoneyRecordInList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppMoneyRecordInList() {
                this.resetMppMoneyRecordInList();
                this.getMppMoneyRecordInList();
            },
            getMppMoneyRecordInList(query = {}) {
                this.loading = true;
                if (this.timeRange.length != null) {
                    this.queryForm.startTime = this.timeRange[0];
                    this.queryForm.endTime = this.timeRange[1];
                }

                get(`/mpp/moneyrecordin/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppMoneyRecordInList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppMoneyRecordInById() {
                get(`/mpp/moneyrecordin/get`,{ id: this.currentMppMoneyRecordInId }).then((res) =>{
                    if(res.success){
                      this.mppMoneyRecordIn = { ...this.mppMoneyRecordIn, ...res.mppMoneyRecordIn };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppMoneyRecordInList() {
                //this.btnLoading = true;
                exprotExcel(`/finance/moneyrecordin/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/moneyrecordin/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/moneyrecordin/importData`,formData);
              this.refreshMppMoneyRecordInList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppMoneyRecordInList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppMoneyRecordInList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>